import * as Highcharts from 'highcharts';

import {Component, Inject, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AdvancedCharts} from 'shared/dtos/cockpit/advancedCharts/advanced-charts';
import {QQplot} from 'shared/dtos/cockpit/advancedCharts/qqplot';
import {DataStorageService} from 'shared/services/data-storage.service';
import {CockpitChartComponent} from '../../../../cockpit-shared/cockpit-content-component';
import {
  ChartTemplateService,
  ChartType,
  Xaxis,
  Yaxis
} from '../../../../cockpit-shared/charts-templates/chart-template.service';

@Component({
  selector: 'app-chart-dialog-qq-plot',
  templateUrl: './chart-dialog-qq-plot.component.html',
  styleUrl: './chart-dialog-qq-plot.component.scss',
  providers: [ChartTemplateService],
  standalone: false
})
export class ChartDialogQqPlotComponent
  extends CockpitChartComponent
  implements OnInit
{
  qqplot: QQplot;

  constructor(
    @Inject(ChartTemplateService)
    private readonly chartTemplateService: ChartTemplateService,
    private readonly dataStorageService: DataStorageService,
    private readonly translateService: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.dataStorageService
      .getAdvancedChartsData()
      .then((data: AdvancedCharts) => {
        if (data?.qqplot) {
          this.qqplot = data.qqplot;
          this.initialize(this.qqplot);

          this.translateService.onLangChange.subscribe(() => {
            const svgContainer = document.getElementById('svgChartQqPlot');
            if (svgContainer) {
              this.initialize(this.qqplot);
            }
          });
        }
      });
  }

  exportChart() {
    this.chart.exportChart(
      {
        type: 'application/pdf',
        filename: 'my-pdf'
      },
      {}
    );
  }

  initialize(data: QQplot) {
    this.chartTemplateService.chartname = 'qqPlot';
    this.initHighCharts(data);
  }

  private initHighCharts(data: QQplot) {
    const series = JSON.parse(
      this.chartTemplateService.translateChart(data.series)
    );

    const chartType = {
      type: 'scatter'
    } as ChartType;

    const chartTitle = {
      text: this.translateService.instant(
        'm1.sprint5.cockpit.card.chart.grafischerModellcheck.qqPlot.title'
      ),
      style: {color: '#333333', fontSize: '18px', fontWeight: 'bold'}
    };

    const xAxis = {
      title: {
        text: this.translateService.instant(
          'm1.sprint5.cockpit.card.chart.grafischerModellchek.qqPlot.x-Achse'
        )
      }
    } as unknown as Xaxis;

    const yAxis = {
      title: {
        text: this.translateService.instant(
          'm1.sprint5.cockpit.card.chart.grafischerModellcheck.qqPlot.y-Achse'
        )
      }
    } as unknown as Yaxis;

    const legend = {reversed: false};
    const tooltip = {
      useHTML: true,
      // eslint-disable-next-line object-shorthand
      formatter: function () {
        return `<svg width="16" height="16">${this.point.series.legendSymbol.element.outerHTML}</svg>${this.series.name}</b><br/>
        <span style="color:${this.series.color}">x</span>: <b>${this.point.x}</b><br/>
        <span style="color:${this.series.color}">y</span>: <span style="font-weight:bold;">${this.point.y}</span><br/>`;
      }
    };

    const stacking = null;

    this.chartTemplateService.initializeChartValues(
      series,
      chartTitle,
      xAxis,
      yAxis,
      legend,
      stacking,
      tooltip,
      chartType
    );

    Highcharts.chart(
      'svgChartQqPlot',
      this.chartTemplateService.json,
      thechart => this.callBackFuncToNormalizeBarChart(thechart)
    );
  }

  private callBackFuncToNormalizeBarChart(thechart: Highcharts.Chart) {
    this.chart = thechart;
    thechart.reflow();
  }
}
